import { createRouter, createWebHashHistory } from 'vue-router'
/* Layout */
import Layout from '@/layout/index.vue'
/** *************登录后所有角色具备的固定菜单*************** */
export const constantRouterMap = [
  {
    path: '/',
    component: Layout,
    // redirect: "/layout/index",
    hidden: false,
  },
  {
    path: '/ruzhu',
    component: () => import('@/views/ruzhu.vue'),
    meta: {
      transition: 'out-in',
    },
    hidden: true,
  },
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior(to, from, savedPosition) {
    return {
      top: 0,
    }
  },
  routes: constantRouterMap,
})

export default router
